module.exports = __webpack_public_path__ + "cm.f14360b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mocks/cm.png
// module id = 2386
// module chunks = 0